export default "__VITE_ASSET__BUv$d$KV__"